import React, { useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
    margin-top: 2rem;
    display: flex;
    justify-content: center;
`;

const Card = styled.div`
    width: 100%;
    max-width: 600px;
    padding: 2rem;
    box-shadow: 0 0 10px rgba(169, 169, 169, 1.0);
    border-radius: 10px;
    background-color: #fff;
`;



const InputGroup = styled.div`
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1rem;
    flex-direction: column; /* Stack on mobile by default */

    @media (min-width: 576px) {
        flex-direction: row; /* Side-by-side layout for larger screens */
    }
`;

const Input = styled.input`
    flex: 1;
    padding: 0.75rem;
    font-size: 1rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    width: 100%;
`;

const Button = styled.button`
    padding: 0.75rem;
    font-size: 1rem;
    color: #fff;
    background-color: #007bff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    width: 100%;

    &:hover {
        background-color: #0056b3;
    }

    @media (min-width: 576px) {
        width: auto; /* Adjust width for larger screens */
    }
`;

const Alert = styled.div`
    margin-top: 1rem;
    padding: 0.75rem;
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
    border-radius: 4px;
`;

const HeadersContainer = styled.div`
    margin-top: 1.5rem;
`;

const HeadersPre = styled.pre`
    padding: 1rem;
    background-color: #f8f9fa;
    border: 1px solid #ced4da;
    border-radius: 4px;
    white-space: pre-wrap;
    width: 95%;
`;

function HeaderChecker() {
    const [url, setUrl] = useState('');
    const [headers, setHeaders] = useState(null);
    const [error, setError] = useState(null);

    const handleCheckHeaders = async () => {
        try {
            setError(null);
            const response = await fetch('check-header-https/checkHeaders.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ url }),
            });
            const data = await response.json();
            if (response.ok) {
                setHeaders(data.headers || 'No headers found.');
            } else {
                setError(data.error || 'An error occurred');
            }
        } catch (err) {
            setError('Failed to fetch headers');
        }
    };

    return (
        <Container>
            <Card>
                <InputGroup>
                    <Input
                        type="text"
                        placeholder="https://www.microsoft.com/"
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                    />
                    <Button onClick={handleCheckHeaders}>Check Header</Button>
                </InputGroup>
                {error && <Alert>{error}</Alert>}
                {headers && (
                    <HeadersContainer>
                        <HeadersPre>{headers}</HeadersPre>
                    </HeadersContainer>
                )}
            </Card>
        </Container>
    );
}

export default HeaderChecker;
